import React, {Component} from 'react'

import Talentcoflow from '../img/talentcoflow.svg'

import {bgWhite} from '../helper/consts'

const style = {
  spacerContainer:{
    position:'relative',
    width: '100vw',
    backgroundColor:bgWhite,
    height:'0',
    top: 'calc((100vw * 0.209125817)/-2)',
    zIndex:'1',
  },
  spacerImg:{
    width:'100vw',
    top: 'calc((100vw * 0.209125817)/2)',
  },
  spacerImgFlip:{
    transform: 'rotateY(180deg)',
  }
}

export default class LandingPageSpacer extends Component{
  render(){
    const {flip} = this.props;
    return (
      <div style={style.spacerContainer} className="spaceImgContainer"><img style={flip?{...style.spacerImg,...style.spacerImgFlip}:style.spacerImg} src={Talentcoflow} alt=""/></div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageSpacer.js